import React from 'react';

interface Props {
  onTest: () => void;
  isLoading: boolean;
  status: 'idle' | 'success' | 'error';
  errorMessage?: string;
}

const ConnectionTest: React.FC<Props> = ({ onTest, isLoading, status, errorMessage }) => {
  return (
    <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
      <button
        type="button"
        onClick={onTest}
        disabled={isLoading}
        className="flex items-center px-4 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 disabled:opacity-50"
      >
        {isLoading ? (
          <>
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600 mr-2" />
            Testing Connection...
          </>
        ) : (
          'Test Connection (optional)'
        )}
      </button>

      {status === 'success' && (
        <p className="text-green-600 text-sm mt-2 flex items-center">
          ✓ Connection successful! Provider credentials are valid.
        </p>
      )}

      {status === 'error' && errorMessage && (
        <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
      )}
    </div>
  );
};

export default ConnectionTest;